<template>
  <div>
    <LoginModal 
      :show="showLoginModal" 
      @close="closeLoginModal" 
      @success="handleAuthSuccess" 
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoginModal from './LoginModal.vue';

export default {
  name: 'AuthHandler',
  components: {
    LoginModal
  },
  data() {
    return {
      showLoginModal: false
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated'])
  },
  methods: {
    ...mapActions('auth', ['checkAuth']),
    
    openLoginModal() {
      this.showLoginModal = true;
    },
    
    closeLoginModal() {
      this.showLoginModal = false;
    },
    
    handleAuthSuccess() {
      this.closeLoginModal();
      // Optionally refresh the current page or redirect
      this.$emit('auth-success');
    },
    
    handleShowAuthModal() {
      // Always show modal when event is triggered, regardless of Vuex state
      // The event is only dispatched when there's actually an auth issue
      this.openLoginModal();
    }
  },
  
  async mounted() {
    // Check if user is already authenticated on app start
    await this.checkAuth();
    
    // Listen for auth modal events
    window.addEventListener('show-auth-modal', this.handleShowAuthModal);
  },
  
  beforeUnmount() {
    window.removeEventListener('show-auth-modal', this.handleShowAuthModal);
  }
};
</script> 